import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationMsgs } from 'src/app/core/Constants/static';
import { UserType } from 'src/app/core/Models/interfaces/payloads/userType';
import { Role } from 'src/app/core/Models/interfaces/role';
import { UserManagementService } from 'src/app/features/user-management/service/user-management.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { RolesService } from '../../service/roles.service';
import { RoleDetails } from 'src/app/core/Models/interfaces/roleDetails';
import { forkJoin } from 'rxjs';
import { RoleManagePayload } from 'src/app/core/Models/interfaces/payloads/roleManagePayload';

@Component({
  selector: 'app-add-edit-role',
  templateUrl: './add-edit-role.component.html',
  styleUrls: ['./add-edit-role.component.css']
})
export class AddEditRoleComponent implements OnInit {
  @Output('closeAddEdit') close: EventEmitter<boolean> = new EventEmitter();
  @Input('isEdit') isEdit: boolean = false;
  @Input('selectedItem') selectedItem!: Role;

  private roleDetails!: RoleDetails

  public fetchingInProgress: boolean = false;
  public roleForm!: FormGroup;
  public showAddEdit: boolean = false;
  public rolesList: Role[] = [];
  public userTypeList: UserType[] = [];
  public formSubmitted: boolean = false;
  public validationMsg = ValidationMsgs.requiredMsg;
  constructor(
    private userManage: UserManagementService,
    private toasterandLoader: ToasterService,
    private roleService: RolesService
  ) { }

  private createForm(): void {
    this.roleForm = new FormGroup({
      roleName: new FormControl(null, Validators.required),
      userType: new FormControl(null, Validators.required),
      isActive: new FormControl(1),
    });
    if (!this.isEdit) {
      this.roleForm.controls['isActive'].disable();
    }
  }

  private getUserTypeList(): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.userManage.getUserTypes().subscribe({
      next: (res) => {
        this.userTypeList = res?.data;
        this.toasterandLoader.isLoaderEnable(false);
        this.showAddEdit = true;
      },
      error: (err) => {
        this.toasterandLoader.isLoaderEnable(false);
        this.showAddEdit = false;
        this.closeAddEdit();
      }
    })
  }

  private editRole() {
    this.roleService.getRoleDetails(this.selectedItem.id).subscribe({
      next: (res) => {
        this.roleDetails = res.data[0];
        this.roleForm.patchValue({
          roleName: this.roleDetails.name,
          userType: this.roleDetails.user_types,
          isActive: this.roleDetails.isActive
        })
        this.toasterandLoader.isLoaderEnable(false);
        this.showAddEdit = true;
      },
      error: (err) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message,
        });
        this.toasterandLoader.isLoaderEnable(false);
        this.showAddEdit = false;
        this.closeAddEdit();

      }
    })
  }

  private addNewRole(): void {
    this.fetchingInProgress=true;
    const roleFormValues = this.roleForm.value;
    const payload: RoleManagePayload = {
      roleName: roleFormValues.roleName || '',
      userTypeId: roleFormValues.userType.userTypeId || ''
    }
    this.roleService.addRole(payload).subscribe({
      next: (res) => {
        this.toasterandLoader.alert.toast({
          title: 'Success',
          type: 'success',
          message: 'Role Added Successfully',
        });
        this.fetchingInProgress = false;
        this.closeAddEdit();

      },
      error: (err) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message,
        });
        this.fetchingInProgress = false;
      },
    })

  }



  private updateRole(): void {
    this.fetchingInProgress=true;
    const roleFormValues = this.roleForm.value;
    const payload: RoleManagePayload = {
      roleName: roleFormValues.roleName || '',
      userTypeId: roleFormValues.userType.userTypeId || '',
      isActive: roleFormValues.isActive || ''
    }
    this.roleService.editRole(payload, this.selectedItem.id).subscribe({
      next: (res) => {
        if(res.status== "Fail"){
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: res.message,
          });
          this.fetchingInProgress = false;
        }
        else{
          this.toasterandLoader.alert.toast({
            title: 'Success',
            type: 'success',
            message: 'Role Updated Successfully',
          });
          this.fetchingInProgress = false;
          this.closeAddEdit();

        }
      },
      error: (err) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message,
        });
        this.fetchingInProgress = false;
      },
    })
  }

  public ngOnInit(): void {
    this.createForm();
    this.getUserTypeList();
    if (this.isEdit && this.selectedItem) {
      this.editRole();
    }
  }

  public saveRole(): void {
    this.formSubmitted = true;
    if (this.roleForm.valid) {
      if (this.isEdit) {
        this.updateRole();
      } else {
        this.addNewRole();
      }
    }
  }

  public closeAddEdit(): void {
    this.showAddEdit = false;
    setTimeout(() => {
      this.close.emit();
    }, 100);
  }

}
